import React from 'react';
import * as lib from '~/dependencies';
import { Container, Bar } from './styles';

export default function SignalIndicator({ score }) {
  function getBarLen(val) {
    let barLength;

    if (val > 0 && val < 3.1) {
      barLength = [1, 0, 0, 0];
    } else if (val >= 3.1 && val < 3.6) {
      barLength = [1, 1, 0, 0];
    } else if (val >= 3.6 && val < 4.03) {
      barLength = [1, 1, 1, 0];
    } else if (val > 4.03) {
      barLength = [1, 1, 1, 1];
    } else {
      barLength = [0, 0, 0, 0];
    }

    return barLength;
  }

  const barLen = getBarLen(score);

  return (
    <Container>
      {barLen.map((e, index) => (
        // eslint-disable-next-line
        <Bar key={index} barLen={e} height={index + 2} />
      ))}
    </Container>
  );
}

SignalIndicator.defaultProps = {
  score: 0,
};

SignalIndicator.propTypes = {
  score: lib.PropTypes.number,
};
